import eventParticipantModel from "./eventParticipantModel";

export default {
    key: null,
    gallery: [],
    event_at: null,
    title: null,
    description: null,
    event_participants: [],
    audio_records: [],
}